"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOH = function MOH(props) {
	return _react2.default.createElement(
		_SvgIcon2.default,
		(0, _extends3.default)({ viewBox: "0 0 384 384", className: "custom-icon" }, props),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M64,0v80H0v144h64v160h224l96-96V0H64z M16,208V96h240v112H16z M288,361.376V288h73.376L288,361.376z M368,272h-96v96H80 V224h192V80H80V16h288V272z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "81.552,117.856 71.664,166.24 71.472,166.24 61.68,117.856 41.136,117.856 41.136,186.4 53.808,186.4  53.808,131.68 54.016,131.68 66.208,186.4 76.96,186.4 89.136,131.68 89.344,131.68 89.344,186.4 102,186.4 102,117.856 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M160.192,137.776c-0.48-4.368-1.52-8.144-3.168-11.28c-1.616-3.12-3.984-5.584-7.04-7.344 c-3.072-1.744-7.2-2.64-12.384-2.64c-5.168,0-9.312,0.896-12.368,2.64c-3.072,1.76-5.408,4.224-7.056,7.344 c-1.616,3.136-2.688,6.912-3.168,11.28c-0.464,4.4-0.704,9.184-0.72,14.352c0,5.232,0.256,10.048,0.72,14.384 c0.48,4.352,1.536,8.096,3.168,11.232c1.632,3.136,3.984,5.536,7.056,7.2c3.056,1.648,7.2,2.496,12.368,2.496 c5.184,0,9.312-0.832,12.384-2.496c3.056-1.664,5.408-4.064,7.04-7.2c1.632-3.136,2.688-6.88,3.168-11.232 c0.48-4.336,0.72-9.152,0.72-14.384C160.912,146.944,160.672,142.16,160.192,137.776z M146.816,163.888 c-0.224,3.232-0.672,5.856-1.344,7.872c-0.672,2.016-1.632,3.472-2.88,4.416c-1.264,0.928-2.912,1.392-4.96,1.392 c-2.048,0-3.696-0.464-4.944-1.392c-1.248-0.928-2.208-2.4-2.88-4.416s-1.12-4.64-1.344-7.872s-0.336-7.136-0.336-11.744 c0-4.608,0.096-8.512,0.336-11.712c0.224-3.2,0.672-5.824,1.344-7.872c0.672-2.048,1.632-3.52,2.88-4.448 c1.264-0.944,2.896-1.408,4.944-1.408c2.048,0,3.712,0.464,4.96,1.408c1.248,0.912,2.208,2.4,2.88,4.448s1.136,4.672,1.344,7.872 c0.208,3.2,0.336,7.104,0.336,11.712C147.152,156.752,147.04,160.656,146.816,163.888z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "203.408,117.856 193.216,168.544 192.928,168.544 183.264,117.856 168.48,117.856 184.224,186.4 201.968,186.4  217.712,117.856 \t\t" })
			)
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
};

exports.default = MOH;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/moh.js
// module id = 1920
// module chunks = 1143